import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./redux/getStore";
// import Header from "./components/header";

import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import LanguageProvider from "./context/language";

const store = configureStore();
const hostname = window.location.hostname;

const isSwarmage = hostname.includes("swarmage.net");
const isMaxVoting = hostname.includes("maxvoting.org");

// 1️⃣ Redirect swarmage.net → /maxvoting
if (isSwarmage && !window.location.pathname.startsWith("/maxvoting")) {
  window.location.replace(
    `/maxvoting${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

// 2️⃣ Redirect maxvoting.org → /
if (isMaxVoting && window.location.pathname !== "/") {
  window.location.replace(
    `/${window.location.search}${window.location.hash}`
  );
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={isSwarmage ? '/maxvoting' : '/'}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
